import React,{ useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';

import logo from '../../../image/logo.svg'

import './Patents.less'

const Patents = () =>{
  const navigate = useNavigate();

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(width > 770){
    return (
      <div className="Patents-page">
        <div style={{borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
          <div className="bigTitle">
            Our Patents
          </div>
        </div>
  
        <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', margin: '70px auto'}}>
          <div style={{ margin: '70px auto'}}>
            <div style={{width: '55%', fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)'}}>
              <span style={{verticalAlign: 'middle'}}><img style={{width: 'clamp(80px, 72.96px + 1.88vw, 100px)', marginRight: 10}} src={logo} alt="" /></span>
              is the culmination of over 15 years of rigorous scientific research and millions of dollars in investment. We have employed the highest scientific standards and gone to great lengths to ensure that our product is safe, effective, and proprietary. Our intellectual property protection is strong, but consumers should be cautious of copycats looking to profit off our hard work. When you choose Mitopure, you can trust that you are buying from the inventors, and that the safety and quality of our product are unmatched in the industry.
            </div>
          </div>
  
          <div className="Patents-item-content">
            <div className="Patents-item-left">
              <div>United States</div>
            </div>
            <div className="Patents-item-right">
              <div>AAAA9999999999999999</div>
            </div>
          </div>
        </div>
      </div>
    )
  }else{
    
    return (
      <div className="Patents-page">
        <div style={{borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
          <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)', padding: '30px 25px 0'}}>
            Our Patents
          </div>
        </div>

        <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', margin: '50px auto'}}>
          <div style={{ margin: '50px auto'}}>
            <div style={{width: '100%', fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', padding: '0 25px'}}>
              <span style={{verticalAlign: 'middle'}}><img style={{width: 'clamp(80px, 72.96px + 1.88vw, 100px)', marginRight: 10}} src={logo} alt="" /></span>
              is the culmination of over 15 years of rigorous scientific research and millions of dollars in investment. We have employed the highest scientific standards and gone to great lengths to ensure that our product is safe, effective, and proprietary. Our intellectual property protection is strong, but consumers should be cautious of copycats looking to profit off our hard work. When you choose Mitopure, you can trust that you are buying from the inventors, and that the safety and quality of our product are unmatched in the industry.
            </div>
          </div>

          <div className="Patents-item-content">
            <div className="Patents-item-left" style={{paddingLeft: 25}}>
              <div>United States</div>
            </div>
            <div className="Patents-item-right" style={{width: '50%'}}>
              <div>AAAA9999999999999999</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Patents